// extracted by mini-css-extract-plugin
export default {"wrapper":"Ricepasta_wrapper__xu0US","container":"Ricepasta_container__8kw6n","list":"Ricepasta_list__RYM07","products":"Ricepasta_products__udE-4"};